/** Flow 7 — Bilan parent (simulation, no backend) */

export const FLOW7_TITLE = "Flow 7 — Bilan parent";

export const FLOW7_STEPS = [
  "Synthèse des activités réalisées",
  "Temps d'étude par matière",
  "Progression / activités complétées",
  "Alerte légère si nécessaire",
  "Prochaine étape ou prochain objectif",
];

export const PARENT_SUMMARY = [
  ["Séances", "5 séances réalisées sur 6 prévues"],
  ["Temps", "4 h 35 temps d'étude"],
  ["Progrès", "Des progrès en Maths et en Français"],
];

export const SUBJECT_TIME = [
  { label: "Maths", time: "1 h 45", width: "100%", color: "#3B82F6" },
  { label: "Français", time: "1 h 20", width: "76%", color: "#22C55E" },
  { label: "Sciences", time: "50 min", width: "48%", color: "#8B5CF6" },
  { label: "Histoire", time: "30 min", width: "29%", color: "#EAB308" },
  { label: "Anglais", time: "10 min", width: "12%", color: "#EF4444" },
];

export const WEEK_TASKS = [
  { label: "Fiche : Équations (Maths)", done: true },
  { label: "Lecture : Chapitre 4 (Français)", done: true },
  { label: "Exercices : Corps humain", done: true },
  { label: "Révision : dates clés (Histoire)", done: true },
  { label: "Devoir : texte d'argumentation", done: true },
  { label: "Exercices : fonctions (Maths)", done: false },
];

export const NEXT_GOALS = [
  "Terminer les exercices de fonctions (Maths)",
  "Lire le chapitre 5 (Français)",
  "Préparer le contrôle (Sciences)",
];

function de(studentName) {
  const name = studentName || "Émile";
  return /^[aeiouyéèêëàâîïôöùûüh]/i.test(name) ? `d'${name}` : `de ${name}`;
}

export function helloMessage(studentName) {
  return `Bonjour ! Voici le résumé de la semaine ${de(studentName)} (Secondaire 3). Une bonne semaine dans l'ensemble !`;
}

export const WEEKLY_NOTE =
  "Vous recevrez un résumé chaque semaine. Nous vous alerterons uniquement en cas de besoin.";

export function subjectsIntro(studentName) {
  return `Voici le temps d'étude ${de(studentName)} cette semaine (9 – 15 oct.).`;
}

export const BALANCE_MESSAGE =
  "Un bon équilibre cette semaine ! Il a bien travaillé en Maths et en Français.";

export const PROGRESS_MESSAGE =
  "Les activités prévues cette semaine sont presque toutes complétées !";

export const REGULAR_MESSAGE =
  "Il maintient une bonne régularité. Continuez comme ça !";

export function alertMessage(studentName) {
  const name = studentName || "Émile";
  return `Petit point d'attention : ${name} n'a pas encore terminé les exercices de fonctions (Maths) prévus cette semaine.`;
}

export const ENCOURAGE_MESSAGE =
  "Souhaitez-vous l'encourager ? Un petit mot de votre part peut faire la différence !";

export const ADVICE_MESSAGE =
  "Conseil de Plan Étude : vous pouvez lui proposer un moment calme ce week-end pour les terminer.";

export const NEXT_MESSAGE = "Prochain objectif pour la semaine du 16 – 22 oct.";

export function noteMessage(studentName) {
  const name = studentName || "Émile";
  return `Ces objectifs ont été définis avec ${name} selon son plan d'apprentissage.`;
}

export const THANKS_MESSAGE =
  "Vous serez informé(e) du bilan de la semaine prochaine. Merci pour votre soutien !";

export function flow7DisplayIndex(flowStep) {
  if (flowStep <= 0) return 0;
  if (flowStep === 1) return 1;
  if (flowStep === 2) return 2;
  if (flowStep === 3) return 3;
  return 4;
}

export const FLOW7_REPLIES = {
  subjects: [{ id: "f7-subjects", label: "Voir le temps par matière", primary: true }],
  progress: [{ id: "f7-progress", label: "Voir la progression", primary: true }],
  alert: [{ id: "f7-alert", label: "Voir le point d'attention", primary: true }],
  details: [{ id: "f7-details", label: "Voir les détails", primary: true }],
  bridge: [{ id: "f7-start", label: "Voir le bilan parent", primary: true }],
};

function result(messages, quickReplies, flowStep) {
  return {
    messages,
    quickReplies,
    flowStep,
    status: FLOW7_STEPS[flow7DisplayIndex(flowStep)],
    planReady: true,
  };
}

/** Instant history for a sommaire step (display index 0–4). */
export function buildFlow7Snapshot(displayIndex, studentName = "Émile") {
  const step = Math.min(Math.max(displayIndex, 0), FLOW7_STEPS.length - 1);
  const messages = [
    { sender: "agent", messageKey: "f7.hello", text: helloMessage(studentName) },
    { sender: "agent", kind: "parentSummary" },
    { sender: "agent", messageKey: "f7.weekly", text: WEEKLY_NOTE },
  ];
  if (step === 0) return result(messages, FLOW7_REPLIES.subjects, 0);

  messages.push({ sender: "user", text: "Voir le temps par matière" });
  messages.push({ sender: "agent", messageKey: "f7.subjects", text: subjectsIntro(studentName) });
  messages.push({ sender: "agent", kind: "subjectBars" });
  messages.push({ sender: "agent", messageKey: "f7.balance", text: BALANCE_MESSAGE });
  if (step === 1) return result(messages, FLOW7_REPLIES.progress, 1);

  messages.push({ sender: "user", text: "Voir la progression" });
  messages.push({ sender: "agent", messageKey: "f7.progress", text: PROGRESS_MESSAGE });
  messages.push({ sender: "agent", kind: "taskList" });
  messages.push({ sender: "agent", messageKey: "f7.regular", text: REGULAR_MESSAGE });
  if (step === 2) return result(messages, FLOW7_REPLIES.alert, 2);

  messages.push({ sender: "user", text: "Voir le point d'attention" });
  messages.push({ sender: "agent", messageKey: "f7.alert", text: alertMessage(studentName) });
  messages.push({ sender: "agent", messageKey: "f7.encourage", text: ENCOURAGE_MESSAGE });
  messages.push({ sender: "agent", messageKey: "f7.advice", text: ADVICE_MESSAGE });
  if (step === 3) return result(messages, FLOW7_REPLIES.details, 3);

  messages.push({ sender: "user", text: "Voir les détails" });
  messages.push({ sender: "agent", messageKey: "f7.next", text: NEXT_MESSAGE });
  messages.push({ sender: "agent", kind: "nextGoals" });
  messages.push({ sender: "agent", messageKey: "f7.note", text: noteMessage(studentName) });
  messages.push({ sender: "agent", messageKey: "f7.thanks", text: THANKS_MESSAGE });
  return result(messages, [], 4);
}
